import { useSearchParams } from "react-router-dom"
import NewsFeedNewmeTrendPopup from "./NewsFeedNewmeTrendPopup"

const NewsFeedNewmeTrend = () => {

  const [searchParams, setSearchParams] = useSearchParams()


  return <NewsFeedNewmeTrendPopup
    gender={searchParams.get('gender')}
    category={searchParams.get('category')}
    tag={searchParams.get('tag')}
    value={searchParams.get('value')}
    retailer={searchParams.get('retailer')}
    isPage={true}
  />

}

export default NewsFeedNewmeTrend
